<template>
	<div>
		<div v-for="(item,itemIndex) in showdata" :key="itemIndex" class="o-f-h">
			<div class="whiteRaduisBox">
					<div class="borderBottom mb8">
						<div v-for="(data,perIndex) in item.nameList" class="blackFont plr4">{{data}}</div>
					</div>
					<div  class='flex mb8'  v-if="item.upper!==null">
						<span class="labelWidth blackFont">上半工时</span>
						<span :class="[' labelWidth',item.upper?'blackFont':'darkGrayFont']">
							{{item.upper?item.upper.vc_bcnote:''}}
						</span>
						<div>
							<div class="flex a-i-c mb8" >
								<span class="blackFont labelWidth85">产出外时长</span>
								<el-input-number style="width: 220px"
							  size="mini"
							  clearable class="blackFont" v-model="item.f_outofproduce_upper":min="0" :controls="false" placeholder="请输入时长" ></el-input-number>
<!--										<uni-easyinput class="blackFont" v-model="item.f_outofproduce_upper" type="digit" placeholder="请输入时长"></uni-easyinput>-->
							</div>
							<div class="flex a-i-c mt8">
								<span class="blackFont labelWidth85">计划检修时长</span>
								<el-input-number style="width: 220px"
							  size="mini"
							  clearable class="blackFont" v-model="item.f_planoverhaul_upper" :controls="false" :min="0" placeholder="请输入时长" ></el-input-number>
<!--										<uni-easyinput class="blackFont" v-model="item.f_planoverhaul_upper" type="digit" placeholder="请输入时长"></uni-easyinput>-->
							</div>
						</div>
					</div>
					<div  class='flex ' v-if="item.lower!==null">
						<span class="labelWidth blackFont">下半工时</span>
						<span :class="[' labelWidth',item.lower?'blackFont':'darkGrayFont']">
							{{item.lower?item.lower.vc_bcnote:''}}
						</span>
						<div>
							<div class="flex a-i-c mb8" >
								<span class="blackFont labelWidth85">产出外时长</span>
								<el-input-number style="width: 220px"
							  size="mini"
							  clearable class="blackFont" v-model="item.f_outofproduce_lower":min="0" :controls="false" placeholder="请输入时长"></el-input-number>
<!--										<uni-easyinput class="blackFont" v-model="item.f_outofproduce_lower" type="digit" placeholder="请输入时长"></uni-easyinput>-->
							</div>
							<div class="flex a-i-c mt8">
								<span class="blackFont labelWidth85">计划检修时长</span>
								<el-input-number style="width: 220px"
							  size="mini"
							  clearable class="blackFont" v-model="item.f_planoverhaul_lower" :min="0" :controls="false" placeholder="请输入时长" ></el-input-number>
<!--										<uni-easyinput class="blackFont" v-model="item.f_planoverhaul_lower" type="digit" placeholder="请输入时长"></uni-easyinput>-->
							</div>
						</div>
					</div>
				</div>

		</div>
		<div class="buttonRow center mTop14">
		<el-button class='popCancelBtn' @click="closepop" :disabled="disableCan" size="mini">取消</el-button>
			<el-button class='popSaveBtn' @click="save" :disabled="disableCan" type="primary" size="mini">提交</el-button>
<!--			<button class="editButton" @click="save">{{$t('button_save')}}</button>-->
		</div>
<!--		<div class="cusPage">-->
<!--			<uni-popup ref="savePop" class='pop' :mask-click='false'>-->
<!--				<div  class="titleTxt p9">机修时长</div>-->
<!--				<div class="blackFont">{{changf_outofproduceTXT}}</div>-->
<!--				<div class="mTop14">-->
<!--					<button class='popCancelBtn' @click="closepop" :disabled="disableCan">取消</button>-->
<!--					<button class='popSaveBtn' @click="addPlanOverhaul" :disabled="disableCan">提交</button>-->
<!--				</div>-->
<!--			</uni-popup>-->
<!--		</div>-->
	</div>
</template>

<script>
	import * as API from "./../api"
	import {mapActions} from "vuex";

	export default {
		props:{
			data:{
				type:Object,
				required:true
			}
		},
		data() {
			return {
				chooseList:[],
				scrollHeight: '',
				screenHeight: '',
				showup:[],
				showlow:[],
				showList:[],
				disableCan:false,
				showdata:[],
				changf_outofproduceTXT:'是否保存更改?'
			}
		},
		mounted() {
			this.chooseList=JSON.parse(JSON.stringify(this.data.chooseList))
			this.bcList=JSON.parse(JSON.stringify(this.data.bcList))
			this.perList=[]
			this.chooseList.map(b=>{
				if(b.i_id!=0&&b.i_bcid!==0&&b.i_iswork!==0){this.perList.push(b.i_uid)}
				// if(b.i_id!=0&&b.i_bcid!==0&&b.i_bcid!==27){this.perList.push(b.i_uid)}
			})
			this.bcstringList=[];
			for(let i=0;i<this.perList.length;i++){
				let per=this.perList[i],bcarr=[],bcstring='';
				bcarr=this.chooseList.filter(c=>c.i_uid==per)
				for(let j=0;j<bcarr.length;j++){
					if(bcarr[j].i_whichhalf==0){
						bcstring=bcarr[j].i_bcid+'-'+bcstring
					}else{
						bcstring=bcstring+bcarr[j].i_bcid
					}
				}
				let data={};
				let iobj=this.bcstringList.findIndex(b=>b.bcstring==bcstring);
				if(iobj==-1){
					data={bcstring:bcstring,per:[per]}
					this.bcstringList.push(data)
				}else{
					let pobj=this.bcstringList[iobj].per.findIndex(p=>p==per)
					if(pobj==-1)this.bcstringList[iobj].per.push(per)
				}
			}
			for(let i=0;i<this.bcstringList.length;i++){
				let bc=this.bcstringList[i],arr=[],bci;
					bci=bc.bcstring.indexOf('-');
				let u,l,hash={},lower,upper,scheduleList=[],nameList=[],f_outofproduce_upper,f_planoverhaul_upper,f_outofproduce_lower,f_planoverhaul_lower;
				if(bci==-1){
					l=bc.bcstring
					u=''
				}else{
					arr=bc.bcstring.split('-');
					u=arr[0]
					l=arr[1]
				}
				if(u){
					upper=this.bcList.find(b=>b.i_bcid==u)
				}else{
					upper=null
				}
				if(l){
					lower=this.bcList.find(b=>b.i_bcid==l)
				}else{
					lower=null			
				}
				// console.log(bc,'p');
				for(let j=0;j<bc.per.length;j++){
					let p=bc.per[j];
					let objList=this.chooseList.filter(c=>c.i_uid==p);
					for(let t=0;t<objList.length;t++){
						let obj=objList[t];
						if(nameList.findIndex(n=>n==obj.vc_uname)==-1){
							nameList.push(obj.vc_uname)
						}
						if(obj.i_whichhalf==0){
							scheduleList.unshift(obj)
							f_outofproduce_upper=bc.per.length==1?obj.f_outofproduce:null
							f_planoverhaul_upper=bc.per.length==1?obj.f_planoverhaul:null
						}else if(obj.i_whichhalf==1){
							scheduleList.push(obj)
							f_outofproduce_lower=bc.per.length==1?obj.f_outofproduce:null
							f_planoverhaul_lower=bc.per.length==1?obj.f_planoverhaul:null
							
						}
					}
					
				}
				hash={
					upper:upper,
					lower:lower,
					f_outofproduce_upper:f_outofproduce_upper,
					f_planoverhaul_upper:f_planoverhaul_upper,
					f_outofproduce_lower:f_outofproduce_lower,
					f_planoverhaul_lower:f_planoverhaul_lower,
					scheduleList:scheduleList,
					nameList:nameList,
				}
				this.showdata.push(hash)
			}
			this.$nextTick(()=>{
				this.onResize();

			})
		},
		watch: {
			'$root.workSize':{
				handler(n,o) {
					this.onResize(n);
				},
				deep:true,
			},
		},
		activated(){
			this.onResize();
		},
		methods:{
			...mapActions(["getCurrentMenuId"]),
			onResize (n){
				if (n==undefined) n=this.$root.workSize;

				$("#homeBox").height(n.h);
				$("#homeBox").width(n.w);
				this.tableHeight= n.h-100

				// console.log(this.tableHeight)
				// $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
				// this.$refs.spread_Edit.onResize();
			},
			closepop(){
				this.$emit('close','back')
			},
			save(){
				let changf_outofproduce=false
				for(let i=0;i<this.chooseList.length;i++){
					if(this.chooseList[i].f_outofproduce||this.chooseList[i].f_planoverhaul){
						changf_outofproduce=true
					}
				}
				if(changf_outofproduce){
					this.$confirm('保存后会覆盖原有值,是否继续?','提示',{
						confirmButtonText:'确定',
						cancelButtonText:'取消',
						type:"warning"
					}).then(()=>{
						this.addPlanOverhaul()
					}).catch(()=>{
						this.$message.info('取消操作')
					})
					// this.changf_outofproduceTXT='保存后会覆盖原有值,是否继续?'
				}else{
					this.addPlanOverhaul()
				}
			},
			async addPlanOverhaul(){
				// this.saveData=[]
				// for(let i=0;i<this.showdata.length;i++){
				// 	let hash={},data=this.showdata[i];
					
				// 	hash.scheduleList=data.scheduleList
				// 	this.saveData.push(hash)
				// }
				// return
				this.disableCan=true
				let param ={ 
					data:this.showdata,
					}
				// this.otherParam=param;
				let res = await API.addPlanOverhaul(param)
				if (res.code == 1) {
					this.closepop()
					this.disableCan=false
					this.$emit('close','save')
				}else{
					this.disableCan=false
					this.$message.error(res.message)
				}
			},
			
		},
	}
</script>

<style lang="scss" scoped>
	.flex{
		display: flex;
	}
	.blackFont{
		display: inline-block;
	}
	.center{
		text-align: center;
	}
	.o-f-h{
		overflow: hidden;
	}
	.labelWidth{
		flex:0 0 65px;
	}
	.labelWidth85{
		flex:0 0 85px;
	}
	.plr4{
		padding-left:4px ;
		padding-right:4px ;
	}
	.right{
		width: 100%;
		text-align: right;
	}
	.w100{
		width: 100%;
	}
	.w-100{
		width: 100px;
	}
	/deep/.uni-data-checklist .checklist-group .checklist-box{
		margin-right: 15px ;
	}
	.btnRow{
		position:fixed;
		bottom:0
	}
	.mTop14{
		margin-top: 24px;
	}
	.pop button{
		background: none;
	}

	.borderBottom{
		border-bottom: 1px solid var(--lightGreyBorder);
	}
	.mb8{
		margin-bottom: 8px;
	}
	.a-i-c{
		align-items: center;
	}
</style>